import React, { useState, useEffect } from "react";
import { Chart, registerables } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { getRequestedandDeliveredCount } from "../Utilities/URLCONSTANTS";
import axios from "axios";
import Box from "../images/box.png";
import DatePicker from "react-datepicker";
import Select from 'react-select';
import { GetApiHeaders } from "../Utilities/NetworkUtilities";
Chart.register(...registerables);

const Requested = () => {
  const [requestedCount, setRequestedCount] = useState([]);
  const [RequestDelvLabels, setRequestDelvLabels] = useState([]);
  const [selectedValue, setSelectedValue] = useState("All");
  const [allCount, setAllCount] = useState();
  const [completedCount, setCompletedCount] = useState();
  const [inProgressCount, setInProgressCount] = useState();
  const [rejectedCount, setRejectedCount] = useState();
  const [hold, setHold] = useState();
  const [postpone, setPostpone] = useState();

  const [pendingCount, setPendingCount] = useState();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const fetchData = async (type) => {
    const formattedStartDate = startDate ? formatDate(startDate) : null;
    const formattedEndDate = endDate ? formatDate(endDate) : null;
    const RequestDeliverdRequest = getRequestedandDeliveredCount;
    const headers = await GetApiHeaders();
    const postData = {
      type: startDate && endDate ? "" : selectedValue,
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    };
    try {
      const response = await axios.post(RequestDeliverdRequest, postData, { headers });
      if (type === "All") {
        setAllCount(response.data.datasets.data[0]); //Requested
        setCompletedCount(response.data.datasets.data[2]); // Completed
        setInProgressCount(response.data.datasets.data[1]); // InProgress
        setRejectedCount(response.data.datasets.data[3]); // Rejected
        setHold(response.data.datasets.data[4]); //Hold
        setPostpone(response.data.datasets.data[5]); // Postpone 
      }
      setRequestedCount(response.data.datasets);
      setRequestDelvLabels(response.data.labels);
    } catch (error) {
      console.log("RequestCount", error);
    }
  };

  useEffect(() => {
    const shouldFetchData = selectedValue === "DTD" && startDate && endDate;
    if (shouldFetchData || selectedValue !== "DTD") {
      fetchData(selectedValue, startDate, endDate);
    }
  }, [startDate, endDate, selectedValue]);

  const data = {
    labels: RequestDelvLabels,
    datasets: [requestedCount],
  };
  console.log("reques", RequestDelvLabels);
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
        align: "start",
        labels: {
          boxWidth: 10,
          padding: 10,
        },
      },
      title: {
        display: true,
        text: "",
        align: "start",
      },
      datalabels: {
        color: '#000',
        font: {
          size: 12,
          weight: 'bold',
        },
        formatter: (value, context) => {
          return value && value !== 0 ? value : null;
        },
        anchor: 'end',
        align: 'start',
      },
      tooltip: {
        callbacks: {
          label: (context) => { },
        },
      },
    },
  };
  const handleSelect = (e) => {
    setSelectedValue(e.target.value);
    setStartDate(null);
    setEndDate(null);
  };
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // added for select custom styles
  const customSelectStyles = {
    option: (provided, state) => ({
      ...provided,
      fontFamily: 'var(--bs-font-secondary)',
      fontWeight: 'normal', // <-- Removes bold styling from options
      fontSize: '12px',
      // Custom background color based on state
      backgroundColor: state.isSelected
        ? 'var(--theme-bg-primary-color)' // Selected background color
        : state.isFocused
          ? 'var(--theme-input-focus-color)' // Hover/Focus background color
          : '#ffffff', // Default background color

      // Custom text color based on state
      color: state.isSelected
        ? '#ffffff' // Selected text color
        : state.isFocused
          ? '#333333' // Hover/Focus text color
          : '#333333', // Default text color

      // Keeps the click/active state looking clean
      ':active': {
        ...provided[':active'],
        backgroundColor: 'var(--theme-bg-primary-color)',
        color: '#ffffff',
        fontSize: '12px',
        fontWeight: 'bold',
      },
    }),
    // 2. Customize the input border focus color
    control: (provided, state) => ({
      ...provided,
      // Changes the border color when focused vs default state
      borderColor: state.isFocused ? 'var(--theme-input-focus-color)' : provided.borderColor,

      // Removes the default blue glow and replaces it (or set to 'none')
      boxShadow: state.isFocused ? '0 0 0 1px var(--theme-input-focus-color)' : provided.boxShadow,

      // Prevents the border from changing back to blue on hover while focused
      '&:hover': {
        borderColor: state.isFocused ? 'var(--theme-input-focus-color)' : provided.borderColor,
        fontSize: '12px',
        fontWeight: 'bold',
      }
    }),
    // 3. Unbold the placeholder text specifically
    placeholder: (provided) => ({
      ...provided,
      fontFamily: 'var(--bs-font-secondary)',
      fontWeight: 'normal',
      fontSize: '12px',
    }),

    // 4. Unbold the selected value text once an option is picked
    singleValue: (provided) => ({
      ...provided,
      fontFamily: 'var(--bs-font-secondary)',
      fontWeight: 'normal',
      fontSize: '12px',
    }),
  };

  const requestTimeframes = [
    { value: "All", label: "ALL" },
    { value: "WTD", label: "Current Week" },
    { value: "MTD", label: "Current Month" },
    { value: "YTD", label: "Yearly" },
    { value: "DTD", label: "Custom selection" }
  ];

  return (
    <>
      <div className="card p-4 ">
        <label className="chartname">
          {" "}
          <img src={Box} style={{ width: 24 }} /> Requested & Completed
        </label>
        <div className="d-flex" id="filtersInputs">
          <Select
            className="basic-single w-25"
            classNamePrefix="select"
            options={requestTimeframes}
            value={requestTimeframes.find((opt) => opt.value === selectedValue)}

            // Adapt the arguments here:
            onChange={(selectedOption) => {
              handleSelect({
                target: {
                  name: "timeframe", // Make sure this matches your state field name
                  value: selectedOption ? selectedOption.value : "" // Pass the value your state needs
                }
              });
            }}
            placeholder="Select "
            // onChange={handleSelect}
            styles={customSelectStyles} //  Your configuration will now work perfectly here!
          />
        </div>
        <div>
          {selectedValue === "DTD" && (
            <div className="d-flex">
              <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                placeholderText="Start Date"
                className="form-control  custom-datepicker"
              />
              <DatePicker
                style={{ marginLeft: "130px  " }}
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                minDate={startDate}
                placeholderText="End Date"
                className="form-control  custom-date"
              />
            </div>
          )}
        </div>

        <div className="d-flex gap-4 justify-content-between align-items-start">
          <ul>
            <li className="countStyle">
              Requested <span style={{ marginLeft: 11 }}>:</span> {allCount}
            </li>
            <li className="countStyle">
              {" "}
              Completed <span style={{ marginLeft: 7 }}>:</span> {completedCount}{" "}
            </li>
            <li className="countStyle">
              InProgress <span style={{ marginLeft: 10 }}>:</span>{" "}
              {inProgressCount}
            </li>
            <li className="countStyle">
              Rejected <span style={{ marginLeft: 23 }}>:</span>{" "}
              {rejectedCount}
            </li>
            <li className="countStyle">
              Postpone <span style={{ marginLeft: 18 }}>:</span>{" "}
              {postpone}
            </li>
            <li className="countStyle">
              Hold <span style={{ marginLeft: 47 }}>:</span>{" "}
              {hold}
            </li>
          </ul>

          <div
            className="chart-container"
            style={{
              width: "300px",
              height: "233px",
              marginTop: "-39px",

            }}
          >
            <Doughnut data={data} options={options} />
          </div>
        </div>
      </div>

    </>
  );
};

export default Requested;
